import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import LandingPMChatsHelmet from 'common/helmets/LandingPMChatsHelmet';
import LazyLoadedImage from 'common/LazyLoadedImage';
import UppercaseHeader from 'common/UppercaseHeader';
import withContexts from 'common/util/withContexts';
import Cover from 'img/landing/pmchats-cover.webp';

import 'css/components/www/_LandingPMChats.scss';

class LandingPMChats extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed PM Chats Page');
  }

  render() {
    return (
      <div className="landingPMChats">
        <LandingPMChatsHelmet />
        <div className="landingPMChatsContainer">
          <div className="hero">
            <LazyLoadedImage className="cover" src={Cover} />
            <div className="text">
              <h1>Product Manager Chats</h1>
              <p>This is PM Chats: a podcast about the ins and outs of product&nbsp;management.</p>
              <p>
                Effective product management is a key factor in running and scaling a successful
                SaaS business. At Canny, we're passionate about building better products—so we
                wanted to put the experiences of product managers front and&nbsp;center.
              </p>
              <p>
                With PM Chats, you’ll get a chance to listen in on a casual, behind-the-scenes
                conversation—not a formal interview. We're hearing about challenges, lessons
                learned, and ins and outs of successful product management, to empower PMs and
                founders to build better&nbsp;products.
              </p>
              <UppercaseHeader>Listen on</UppercaseHeader>
              <div className="platforms">
                <a
                  target="_blank"
                  rel="noopener nofollow"
                  href="https://podcasts.apple.com/us/podcast/product-manager-chats/id1560889615?uo=4">
                  Apple Podcasts
                </a>
                <a
                  target="_blank"
                  rel="noopener nofollow"
                  href="https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy80NzE4MDM4NC9wb2RjYXN0L3Jzcw==">
                  Google Podcasts
                </a>
                <a
                  target="_blank"
                  rel="noopener nofollow"
                  href="https://open.spotify.com/show/2m471O0F8WTscjFEZslwZO">
                  Spotify
                </a>
                <a
                  target="_blank"
                  rel="noopener nofollow"
                  href="https://anchor.fm/product-manager-chats">
                  Anchor
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(withContexts({ trackEvent: TrackEventContext }), hot)(LandingPMChats);
